// extracted by mini-css-extract-plugin
module.exports = {"container":"CodeView_container__1ibLO","icon":"CodeView_icon__168TP"};